import React from 'react';
import Reveal from '../ui/Reveal';
import FaqAccordion from './FaqAccordion';
import { faqItems } from '../../data/masterclass';

const FaqSection: React.FC = () => {
  return (
    <section id="faq" className="relative scroll-mt-36 py-24 md:py-28">
      <div className="mx-auto max-w-3xl px-5">
        <Reveal className="mb-12 text-center">
          <div className="mb-4 flex items-center justify-center gap-3">
            <span className="text-sm text-white/30">08</span>
            <span className="eyebrow-mc text-mc-fuchsia">Preguntas frecuentes</span>
          </div>
          <h2 className="font-display text-3xl font-bold md:text-4xl">Resolvemos tus dudas</h2>
        </Reveal>

        <Reveal delay={80}>
          <FaqAccordion items={faqItems} />
        </Reveal>
      </div>
    </section>
  );
};

export default FaqSection;
